import { render } from "./webh5account.vue?vue&type=template&id=1bb1fe1a&scoped=true"
import script from "./webh5account.vue?vue&type=script&lang=js"
export * from "./webh5account.vue?vue&type=script&lang=js"

import "./webh5account.vue?vue&type=style&index=0&id=1bb1fe1a&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb1fe1a"]])

export default __exports__